import { useSelector } from 'react-redux'
import { selectors } from 'shared/store'
import { useCoutriesOptions } from 'shared/hooks'

export const useCountriesSelectOptions = () => {
  const phonePrefixesOptions = useSelector(
    selectors.settings.getphonePrefixesOptions
  )
  const countriesOptions = useCoutriesOptions()

  return { phonePrefixesOptions, countriesOptions }
}
